import { entrypoint, viewOf } from "../../client/index.ts";
import { designCopy } from "../../design/copy.ts";
import { listQuery } from "./query.ts";

const read = viewOf("conversas");

export const entrypoints = [entrypoint({
  id: "conversas",
  path: "/conversas",
  replaceOn: ["lista", "busca"],
  data: (_: unknown, query: URLSearchParams) => read({}, listQuery(query)),
  view: () => import("./view.tsx"),
  place: () => ({ title: designCopy.lugares.conversas, path: [] }),
})];
